import { render, staticRenderFns } from "./resourceOutManageList.vue?vue&type=template&id=38c7e9a5&scoped=true"
import script from "./resourceOutManageList.vue?vue&type=script&lang=js"
export * from "./resourceOutManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceOutManageList.vue?vue&type=style&index=0&id=38c7e9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7e9a5",
  null
  
)

export default component.exports